<template>
  <div class="snackbar">
    <div class="snackbar__inner">
      <div class="snackbar__icon">
        <img
          src="@/assets/icons/attention.svg"
          alt="icon"
        >
      </div>
      <div class="snackbar__text">
        Срок действия сессии истек, пожалуйста, обновите страницу.
      </div>
      <div
        class="snackbar__refresh"
        @click="refresh"
      >
        Обновить
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useStore } from 'vuex';

import { sendPostMessage } from '@/util/helper';

export default defineComponent({
  setup() {
    const store = useStore();
    
    const refresh = () => {
      sendPostMessage('update_token', 'success', '');
      store.commit('setRefreshToken', false);
      document.location.reload();
    };

    return {
      refresh
    };
  },
});
</script>
<style lang="scss" scoped>
.snackbar{
  padding: 12px 16px;
  background: #FFFFFF;
  border-radius: 4px;
  &__inner{
    display: flex;
    align-items: center;
  }
  &__icon{
    margin-right: 10px;
  }
  &__text{
    margin-right: 5px;
  }
  &__refresh{
    color: $primary-purple;
    font-weight: 500;
    cursor: pointer;
  }
}
@media (min-width: 320px) and (max-width: 768px) {
.snackbar{
  &__inner{
    text-align: center;
    flex-direction: column;
  }
  &__icon{
    margin-right: 0;
    margin-bottom: 10px;
  }
  &__text{
    margin-right: 0;
    margin-bottom: 10px;
  }
}
}
</style>